export default class Housemate {
  constructor(uuid, name, email, phone, roomName = '') {
    this.uuid = uuid
    this.name = name
    this.email = email
    this.phone = phone
    this.roomName = roomName
  }
}
